import { createTwoFilesPatch } from "diff";

/**
 * Build a unified patch that react-diff-view's parseDiff can read.
 *
 * parseDiff runs on gitdiff-parser, and that parser only opens a file when it
 * sees a `diff --git` line. Hand it a bare createTwoFilesPatch output and no
 * file is ever opened, so the first content line throws
 * "Cannot read properties of undefined (reading 'changes')". The git header is
 * required, not decoration.
 *
 * Paths are also sanitised: the parser splits the `---`/`+++` lines on
 * whitespace, so a label like "prompt v1" would truncate to "prompt".
 */
export const buildPromptPatch = (
  promptId: string,
  fromVersion: number,
  toVersion: number,
  oldText: string,
  newText: string,
): string => {
  const slug = promptId.trim().replace(/\s+/g, "_") || "prompt";
  const oldPath = `a/${slug}@v${fromVersion}`;
  const newPath = `b/${slug}@v${toVersion}`;

  return (
    `diff --git ${oldPath} ${newPath}\n` +
    createTwoFilesPatch(oldPath, newPath, oldText, newText, "", "", {
      context: 3,
    })
  );
};
